export const suspiciousColumnData = [
  { Header: 'Action', accessor: 'action' },
  //   { Header: 'Data', accessor: 'data' },
  { Header: 'Player', accessor: 'player' },
  { Header: 'Date', accessor: 'createdAt' }
];
